(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/playmaker-widget/assets/javascripts/playmaker-widget.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/playmaker-widget/assets/javascripts/playmaker-widget.js');
"use strict";


const {
  getBetradarId
} = svs.components.oddset.kambiOffering;
const pmWidgetStyles = svs.components.lbLibs.playmaker.pmWidgetStyles;
class PlaymakerWidget extends HTMLElement {
  static get observedAttributes() {
    return ['eventid'];
  }
  get eventId() {
    return this.getAttribute('eventid');
  }
  async connectedCallback() {
    const shadowRoot = this.attachShadow({
      mode: 'open'
    });
    const betradarId = await getBetradarId(this.eventId);
    if (!betradarId) {
      return;
    }
    shadowRoot.innerHTML = "\n    <div class=\"pm-widget-container\">\n      <div class=\"pm-spider-container live\">\n        <div id=\"pm-live-widget-summary-".concat(betradarId, "\"></div>\n        <div id=\"pm-xg-live-widget-").concat(betradarId, "\"></div>\n        <div id=\"pm-live-widget-spider-").concat(betradarId, "\"></div>\n      </div>\n    </div>\n    ");
    const style = document.createElement('style');
    style.textContent = "\n      ".concat(pmWidgetStyles, "\n      .pm-widget-container .pm-spider-container {\n        margin-bottom: 30px;\n      }");
    shadowRoot.appendChild(style);
    const liveContainer = shadowRoot.querySelector("#pm-live-widget-summary-".concat(betradarId));
    const xgContainer = shadowRoot.querySelector("#pm-xg-live-widget-".concat(betradarId));
    const spiderContainer = shadowRoot.querySelector("#pm-live-widget-spider-".concat(betradarId));
    const pm = window.PM;
    pm('addLiveWidget', {
      matchId: betradarId,
      containerElement: spiderContainer,
      settings: {
        kpis: [],
        theme: 'dark',
        renderRadar: true
      }
    });
    pm('addXgLiveWidget', {
      matchId: betradarId,
      containerElement: xgContainer,
      settings: {
        theme: 'dark',
        renderLegend: false
      }
    });
    pm('addLiveWidget', {
      matchId: betradarId,
      containerElement: liveContainer,
      settings: {
        theme: 'dark',
        renderSummary: true
      }
    });
  }
}
customElements.define('playmaker-widget', PlaymakerWidget);

 })(window);